import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageView } from 'Utilities/ga';

export const useGA = (): void => {
  const location = useLocation();

  useEffect(() => {
    pageView(location.pathname);
  }, [location]);
};

